// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"7c599533","324":"2e7534fb"}[chunkId] + ".chunk.js";
};